import { render, staticRenderFns } from "./AfterAddToCartModal.vue?vue&type=template&id=1122418f&scoped=true"
import script from "./AfterAddToCartModal.vue?vue&type=script&lang=js"
export * from "./AfterAddToCartModal.vue?vue&type=script&lang=js"
import style0 from "./AfterAddToCartModal.vue?vue&type=style&index=0&id=1122418f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1122418f",
  null
  
)

export default component.exports